import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { POSTGetInitiateServices } from "../../../../../../service/PostGetInitiateServices";
import { POSTGetListServices } from "../../../../../../service/POSTGetListServices";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../../../../asset";
import { setGlobalDeliveryAssociate } from "../../../../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSDeliveryAssociateReport = ({
  children,
  togglerClassName,
  placeholder,
  className,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);

  const { globalDepotName } = useSelector((state) => state.globalMSS);
  const {
    valuesMultipleSelectDeliveryAssociateStatus,
    valuesMultipleSelectDriverType,
    valuesMultipleSelectVehicleOwnership,
  } = useSelector((state) => state.globalMultipleSelectValues);

  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [params, setParams] = useState();
  const [bodyRequest, setBodyRequest] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const isDepotHasValue = useMemo(() => {
    if (globalDepotName && globalDepotName.length === 0) {
      return false;
    }
    return true;
  }, [globalDepotName]);

  const isDAStatusHasValue = useMemo(() => {
    if (
      valuesMultipleSelectDeliveryAssociateStatus &&
      valuesMultipleSelectDeliveryAssociateStatus.length === 0
    ) {
      return false;
    }
    return true;
  }, [valuesMultipleSelectDeliveryAssociateStatus]);

  const isDriverTypeHasValue = useMemo(() => {
    if (
      valuesMultipleSelectDriverType &&
      valuesMultipleSelectDriverType.length === 0
    ) {
      return false;
    }
    return true;
  }, [valuesMultipleSelectDriverType]);

  const isVehicleOwnershipHasValue = useMemo(() => {
    if (
      valuesMultipleSelectVehicleOwnership &&
      valuesMultipleSelectVehicleOwnership.length === 0
    ) {
      return false;
    }
    return true;
  }, [valuesMultipleSelectVehicleOwnership]);

  const isEnableDA = useMemo(() => {
    if (
      isDepotHasValue &&
      isDAStatusHasValue &&
      isDriverTypeHasValue &&
      isVehicleOwnershipHasValue
    ) {
      return true;
    }
    return false;
  }, [
    isDAStatusHasValue,
    isDepotHasValue,
    isDriverTypeHasValue,
    isVehicleOwnershipHasValue,
  ]);

  const getTotalData = useCallback(
    async (payload) => {
      const resInitiate = await POSTGetInitiateServices(
        token,
        `delivery-associate/dropdown-report`,
        payload
      );

      if (resInitiate?.success && resInitiate?.initiate) {
        setTotalData(resInitiate?.initiate?.count_data);
      }
    },
    [token]
  );

  const getListDeliveryAssociate = useCallback(
    async (payload) => {
      const res = await POSTGetListServices(
        token,
        `delivery-associate/dropdown-report`,
        payload
      );
      if (res?.success && res?.list !== null) {
        const list = res?.list.map((el) => {
          return {
            id: el?.delivery_associate_id,
            name: `${el?.delivery_associate_id} - ${el?.first_name} ${el?.last_name}`,
          };
        });

        if (payload?.filter && payload?.filter.includes("full_name")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, name: "Select All" });
        setListData([...list]);
      }
      if (res?.success && res?.list === null) {
        setListData([{ id: -1, name: "Select All" }]);
      }
    },
    [token]
  );

  useEffect(() => {
    if (isEnableDA) {
      const depots = [...globalDepotName];
      const depotListId =
        depots && depots.includes(-1)
          ? {
              depot_id_list: { list_id: [-1], exclude: false },
            }
          : {
              depot_id_list: {
                list_id: depots.map((el) => el?.id),
                exclude: false,
              },
            };

      const DAStatus = [...valuesMultipleSelectDeliveryAssociateStatus];
      const DAStatusListId =
        DAStatus && DAStatus.includes(-1)
          ? {
              delivery_associate_status: {
                list: ["Active", "Expired"],
                exclude: false,
              },
            }
          : {
              delivery_associate_status: {
                list: DAStatus.map((el) => el?.id),
                exclude: false,
              },
            };

      const DriverType = [...valuesMultipleSelectDriverType];
      const DriverTypeList =
        DriverType && DriverType.includes(-1)
          ? {
              driver_type: { list: ["Owned", "Outsource"], exclude: false },
            }
          : {
              driver_type: {
                list: DriverType.map((el) => el?.id),
                exclude: false,
              },
            };

      const vehicleOwnership = [...valuesMultipleSelectVehicleOwnership];
      const vehicleOwnershipList =
        vehicleOwnership && vehicleOwnership.includes(-1)
          ? {
              vehicle_ownership_filter: {
                list: ["Owned", "Outsource"],
                exclude: false,
              },
            }
          : {
              vehicle_ownership_filter: {
                list: vehicleOwnership.map((el) => el?.id),
                exclude: false,
              },
            };

      const bodyReq = {
        page: 1,
        limit: 10,
        order: "",
        filter: "",
        connector: "",
        other: {
          ...depotListId,
          ...DAStatusListId,
          ...DriverTypeList,
          ...vehicleOwnershipList,
        },
      };
      getTotalData(bodyReq);
      getListDeliveryAssociate(bodyReq);
      setBodyRequest(bodyReq);
    }
    return;
  }, [
    getListDeliveryAssociate,
    getTotalData,
    globalDepotName,
    isEnableDA,
    valuesMultipleSelectDeliveryAssociateStatus,
    valuesMultipleSelectDriverType,
    valuesMultipleSelectVehicleOwnership,
  ]);

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalDeliveryAssociate([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalDeliveryAssociate([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalDeliveryAssociate([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalDeliveryAssociate([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalDeliveryAssociate([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalDeliveryAssociate([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalDeliveryAssociate([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalDeliveryAssociate([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (isEnableDA) {
      if (!searchKeyword) {
        const resetParams = {
          ...bodyRequest,
          page: 1,
          limit: 10,
          filter: "",
        };
        getListDeliveryAssociate(resetParams);
        return;
      }
      const newParams = {
        ...bodyRequest,
        page: 1,
        limit: 10,
        filter: `full_name lk ${searchKeyword}`,
      };
      getListDeliveryAssociate(newParams);
    }
    return;
  }, [bodyRequest, getListDeliveryAssociate, isEnableDA, searchKeyword]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={`${
          isEnableDA ? "value-mss" : " value-mss-disabled"
        } `.concat(!isEnableDA ? " cursor-not-allowed" : "")}
        onClick={isEnableDA ? togglerDropdownContent : undefined}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Delivery Associate </span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Delivery Associate</span>
        )}
      </button>
      {!isEnableDA ? (
        <span className="font-roboto text-xs font-semibold text-red-100 mt-2">
          * Select Depot, Delivery Associate Status, Driver Type and Vehicle
          Ownership first
        </span>
      ) : (
        false
      )}
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By Name"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSDeliveryAssociateReport;
